module.exports = __webpack_public_path__ + "assets/img/logo-light.6b949d7f.png";